import { DropdownIndicator } from "@/shared/components";
import { ReactSelect } from "@ab.uitools/ui-library/components/ReactSelect";
import type { TReactSelectProps } from "@ab.uitools/ui-library/components/ReactSelect/types";
import { useTranslation } from "react-i18next";

export const Select = (props: TReactSelectProps) => {
  const { t } = useTranslation();
  return (
    <ReactSelect
      menuPosition="fixed"
      noOptionsMessage={() => t("general.noOptionsMessage")}
      {...props}
      components={{
        ...props.components,
        DropdownIndicator
      }}
    />
  );
};
